    document.addEventListener("livewire:navigated", function () {
        const htmlElement = document.documentElement;
        if (document.getElementById("theme-toggle")) {
            document.getElementById("theme-toggle").addEventListener("click", function () {
                if (htmlElement.classList.contains("dark")) {
                htmlElement.classList.remove("dark");
                localStorage.setItem("darkMode", "disabled");
                document.cookie = "darkmode=false; path=/";
                Livewire.dispatch("darkmode:update-bg");

                // Livewire dispatch event
            } else {
                htmlElement.classList.add("dark");
                    localStorage.setItem("darkMode", "enabled");
                    document.cookie = "darkmode=true; path=/";
                    Livewire.dispatch("darkmode:update-bg");

                }
            });

        }

        document.addEventListener("darkmode:update-cookie", function (event) {
            let theme = event.detail[0].theme;
            if (theme === "dark") {
                htmlElement.classList.add("dark");
                localStorage.setItem("darkMode", "enabled");
                document.cookie = "darkmode=true; path=/";
            } else if (theme === "light") {
                htmlElement.classList.remove("dark");
                localStorage.setItem("darkMode", "disabled");
                document.cookie = "darkmode=false; path=/";
            } else if (theme === "auto") {
                localStorage.removeItem("darkMode");
                document.cookie = "darkmode=false; path=/";
            }
        });

        document.addEventListener("darkmode:change-preview", function (event) {
            let theme = event.detail[0].theme;
            if (theme === "dark") {
                htmlElement.classList.add("dark");
            } else if (theme === "light") {
                htmlElement.classList.remove("dark");
            }
        });


    });
